<script lang="ts">
  import { cn } from '$lib/utils';
  import { Button } from '$lib/components/ui/button';
  import type { CtaBlock } from 'query-strapi-v4';
  export let src: string;
  export let alt: string;
  export let height: number;
  export let width: number;
  export let title: string;
  export let description: string;

  export let onClick: () => void = () => {};
  export let link: CtaBlock['link'] = undefined;

  const spacing = 'px-4 py-2.5';
</script>

<div>
  <!-- <div class={cn(spacing)}></div> -->
  <img {src} {alt} {height} {width} class="w-full h-auto" />
  <div class={cn(spacing, 'flex gap-2 justify-between items-center')}>
    <div>
      <div class="font-semibold">{title}</div>
      <div class="text-sm pb-1">
        {description}
      </div>
    </div>
    <div>
      {#if link && link.text}
        <Button variant="outline" on:click={onClick} target={link.target ?? '_self'}
          >{link.text}</Button
        >
      {/if}
    </div>
  </div>
</div>
